
export const disableButon = (id: string) => {
    // @ts-ignore
    const element = window.$(`#${id}`)
    // //console.log(element)
    element.prop("disabled", true)
}